import { styled, Stack, Box } from '@mui/material';
import { lighten } from '@mui/material/styles';

export const DashboardVariantV2CarrierZoneSaturationHeaderContainer = styled(
  Stack,
)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(1.5, 2),
}));

export const DashboardVariantV2CarrierZoneSaturationHeaderLegend = styled(
  Stack,
)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const DashboardVariantV2CarrierZoneSaturationHeaderLegendItemContainer =
  styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  }));

export const DashboardVariantV2CarrierZoneSaturationHeaderLegendDot = styled(
  Box,
  {
    shouldForwardProp: (prop) => prop !== 'dotColor',
  },
)<{ dotColor: string }>(({ dotColor }) => ({
  width: 10,
  height: 10,
  borderRadius: '50%',
  backgroundColor: dotColor,
  color: dotColor,
  position: 'relative',

  '&.pulse': {
    '&:before, &:after': {
      content: '""',
      boxShadow: `0 0 0 0 ${lighten(dotColor, 0.9)}`,
      opacity: 0.7,
      animation: 'pulseKeyFrames 1.3s infinite',
      position: 'absolute',
      height: '100%',
      width: '100%',
      borderRadius: 'inherit',
    },

    '&:after': {
      animationDelay: '0.3s',
    },
  },

  '@keyframes pulseKeyFrames': {
    '100%': {
      boxShadow: `0 0 0 10px currentColor`,
      opacity: 0,
    },
  },
}));
